import { gql } from '@apollo/client';

const CartTransactionInfoPublic = gql`
  fragment CartTransactionInfoPublic on CartTransaction {
    id
    state
    discountAmount
    taxAmount
    shippingAmount
    total
    authcode
    avs
    cvv
    transactionId
    message
    reconciliationRequiredAt
    status
    code
    amountApproved
    taxQuoteId
  }
`;

export default CartTransactionInfoPublic;
